<template>
  <div class="container" :class="{ 'embedded-page': embedded }">
    <!-- 筛选 -->
    <div>
      <el-form :inline="true" :model="filters">
        <el-form-item :label="$t('Operator')" v-show="zong">
          <el-select
            v-model="filters.SellerId"
            :placeholder="$t('Operator')"
            style="width: 150px"
          >
            <el-option
              v-for="item in seller"
              :key="item.SellerId"
              :label="item.SellerName"
              :value="item.SellerId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('channel')">
          <el-select
            v-model="filters.ChannelId"
            :placeholder="$t('channel')"
            style="width: 150px"
            clearable
          >
            <el-option
              v-for="item in channel"
              :key="item.ChannelId"
              :label="item.Name"
              :value="item.ChannelId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ConfigurationName')+':'">
          <el-input
            v-model="filters.ConfigName"
            style="width: 150px"
            :clearable="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Explanation')+':'">
          <el-input
            v-model="filters.Remark"
            style="width: 150px"
            :clearable="true"
            :placeholder="$t('fuzzyQueryDescription')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            v-on:click="handleQuery"
            >{{$t('Search')}}</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="mr10"
            v-show="auth2('增')"
            @click="handleAdd"
            >{{$t('Add')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 表 -->
    <div>
      <el-table
        :data="table_data"
        border
        class="table"
        :cell-style="{ padding: '0' }"
      >
        <el-table-column
          align="center"
          prop="Id"
          :label="$t('SerialNumber')"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('Channel')"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.ChannelId == 0">{{$t('All')}}</span>
            <span v-if="scope.row.ChannelId != 0">{{
              channelmap[scope.row.ChannelId]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="SellerName"
          :label="$t('Operator')"
          width="80"
          v-if="zong"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Remark"
          :label="$t('Explanation')"
          width="450"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ConfigValue"
          :label="$t('ConfigurationValue')"
          width="300"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ConfigName"
          :label="$t('ConfigurationName')"
          width="200"
        ></el-table-column>
        <el-table-column :label="$t('content')">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleModify(scope.$index)"
              >{{$t('Edit')}}</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              v-show="auth2('删')"
              @click="handleDelete(scope.$index)"
              >{{$t('Delete')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :page-sizes="pagesizes"
          :current-page="page"
        >
        </el-pagination>
      </div>
    </div>
    <div>
      <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.show"
        width="600px"
        center
      >
        <el-form :inline="true" label-width="100px">
          <el-form-item :label="$t('Operator')" v-show="zong">
            <el-select
              v-model="dialog.data.SellerId"
              :placeholder="$t('Operator')"
              style="width: 200px"
              @change="changeSellerId"
              :disabled="dialog.type == 'alter'"
            >
              <el-option
                v-for="item in userSellerList"
                :key="item.SellerId"
                :label="item.SellerName"
                :value="item.SellerId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('ConfigurationName')+':'">
            <el-input
              v-model="dialog.data.ConfigName"
              style="width: 400px"
              :disabled="dialog.type == 'alter'"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('ConfigurationValue')+':'">
            <el-input
              type="textarea"
              v-model="dialog.data.ConfigValue"
              style="width: 400px"
              :rows="6"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Explanation')+':'">
            <el-input
              type="textarea"
              v-model="dialog.data.Remark"
              style="width: 400px"
              :rows="8"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">{{ $t('Confirm') }}</el-button>
        </span>
      </el-dialog>
    </div>
    <WinJiangPei
      :show.sync="jiangPeiVisible"
      :dialogData="jiangPeiData"
      @updataInfo="handleQuery(page)"
    ></WinJiangPei>
    <LotteryCommission
      :show.sync="commissionVisible"
      :dialogData="commissionData"
      @updataInfo="handleQuery(page)"
    ></LotteryCommission>
    <!-- 新版首页配置 -->
    <configSmallSort
      v-if="configSortData.show"
      :configSortData="configSortData"
      @confirmSmallSortData="confirmSmallSortData"
    />
    <SystemSettingAddDialog
      v-if="mSettingData.show"
      :dialogData="mSettingData"
      @success="handleQuery(page)"
    />
  </div>
</template>
<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
import "@/assets/css/k.css";
import WinJiangPei from "./config_WinJiangPei.vue";
import LotteryCommission from "./config_LotteryCommission.vue";
import configSmallSort from "./dialog/configSmallSort.vue";
import SystemSettingAddDialog from "./dialog/SystemSettingAddDialog.vue";
export default {
  extends: base,
  name: "systemConfig",
  props: {
    sellerId: {
      type: [Number, String],
      default: "",
    },
    configName: {
      type: String,
      default: "",
    },
    configRemark: {
      type: String,
      default: "",
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WinJiangPei,
    LotteryCommission,
    configSmallSort,
    SystemSettingAddDialog,
  },
  data() {
    return {
      filters: {
        ConfigName: null,
        Remark: null,
      },
      pagesize: 15,
      jiangPeiVisible: false,
      jiangPeiData: {},
      commissionVisible: false,
      commissionData: {},
      configSortData: {
        title: "新版首页",
        show: false,
        data: {},
      },
      mSettingData: {
        show: false,
        title: "",
        row: {},
        opt: 1,
      },
    };
  },
  created() {
    this.app = app;
    this.applyRouteQuery();
    this.handleQuery(1);
    this.getChannel(this.filters.SellerId);
  },
  watch: {
    sellerId() {
      this.reloadByProps();
    },
    configName() {
      this.reloadByProps();
    },
    configRemark() {
      this.reloadByProps();
    },
    $route(to) {
      if (to.name == "systemConfig") {
        this.applyRouteQuery();
        this.handleQuery(1);
      }
    },
  },
  methods: {
    reloadByProps() {
      if (this.embedded) {
        this.applyRouteQuery();
        this.handleQuery(1);
      }
    },
    applyRouteQuery() {
      const query = this.$route.query || {};
      if (this.sellerId !== undefined && this.sellerId !== "") {
        this.filters.SellerId = Number(this.sellerId);
      } else if (query.SellerId !== undefined && query.SellerId !== "") {
        this.filters.SellerId = Number(query.SellerId);
      }
      if (this.configName) {
        this.filters.ConfigName = this.configName;
      } else if (query.ConfigName !== undefined) {
        this.filters.ConfigName = query.ConfigName;
      }
      if (this.configRemark) {
        this.filters.Remark = this.configRemark;
      } else if (query.Remark !== undefined) {
        this.filters.Remark = query.Remark;
      }
      if (query.ChannelId !== undefined && query.ChannelId !== "") {
        this.filters.ChannelId = Number(query.ChannelId);
      }
    },
    auth2(o) {
      return app.auth2("系统管理", "系统设置", o);
    },
    handleDelete(index) {
      if (
        this.table_data[index].ConfigName == "TrxPrice" ||
        this.table_data[index].ConfigName == "RewardPoolTrx" ||
        this.table_data[index].ConfigName == "RewardPoolUsdt"
      ) {
        this.$message.error({ message: "该项不可删除" });
        return;
      }
      if (confirm("确定删除该配置?")) {
        app.getGoogleCode((GoogleCode) => {
          this.table_data[index].GoogleCode = GoogleCode;
          app.post("/admin/config/delete", this.table_data[index], (result) => {
            this.handleQuery(this.page);
            this.dialog.show = false;
          });
        });
      }
    },
    handleAdd() {
      this.mSettingData.title = this.$t('addConfiguration')
      this.mSettingData.row = {};
      this.mSettingData.opt = 2;
      this.mSettingData.show = true;
      // this.dialog.data = {
      //   SellerId: this.filters.SellerId,
      //   ConfigName: null,
      //   ConfigValue: null,
      //   Remark: null,
      // };
      // if (this.dialog.data.SellerId <= 0) this.dialog.data.SellerId = null;
      // this.dialog.type = "add";
      // this.dialog.title = "添加配置";
      // this.dialog.show = true;
    },
    handleModify(index) {
      this.dialog.data = app.clone(this.table_data[index]);
      if (this.dialog.data.EditAble != 1) {
        this.$message.error({ message: "该项不可配" });
        return;
      }
      this.dialog.type = "alter";
      this.dialog.title = this.$t('editConfiguration');

      if (
        this.dialog.data.ConfigName == "WinJiangPeiTrx" ||
        this.dialog.data.ConfigName == "WinJiangPeiUsdt"
      ) {
        this.jiangPeiData = JSON.parse(JSON.stringify(this.dialog));
        this.dialog.show = false;
        this.jiangPeiVisible = true;
      } else if (
        this.dialog.data.ConfigName == "LotteryCommission" ||
        this.dialog.data.ConfigName == "QiPaiCommission" ||
        this.dialog.data.ConfigName == "XiaoYouXiCommission"
      ) {
        this.commissionData = JSON.parse(JSON.stringify(this.dialog));
        this.dialog.show = false;
        this.commissionVisible = true;
      } else if (this.dialog.data.ConfigName == "HomeData") {
        // 新版首页配置  // 新版首页配置
        this.configSortData.show = true;
        this.configSortData.data = this.dialog.data;
      } else {
        // this.dialog.show = true;
        this.mSettingData.row = app.clone(this.table_data[index]);
        this.mSettingData.title = this.$t('editConfiguration');
        this.mSettingData.opt = 1;
        this.mSettingData.show = true;
        this.jiangPeiVisible = false;
      }
    },
    confirmSmallSortData(val) {
      app.getGoogleCode((GoogleCode) => {
        val.GoogleCode = GoogleCode;
        app.post("/admin/config/modify", val, (result) => {
          this.handleQuery(this.page);
          this.configSortData.show = false;
        });
      });
    },
    handleConfirm() {
      app.getGoogleCode((GoogleCode) => {
        this.dialog.data.GoogleCode = GoogleCode;
        if (this.dialog.type == "alter") {
          app.post("/admin/config/modify", this.dialog.data, (result) => {
            this.handleQuery(this.page);
            this.dialog.show = false;
          });
        }
        if (this.dialog.type == "add") {
          app.post("/admin/config/add", this.dialog.data, (result) => {
            this.handleQuery(this.page);
            this.dialog.show = false;
          });
        }
      });
    },
    handleQuery(page) {
      // 查询按钮会把 MouseEvent 作为第一个参数传入，不能因此把当前页重置为 1。
      // 只有分页组件传入有效页码时才更新 page。
      const selectedPage = Number(page);
      if (Number.isFinite(selectedPage) && selectedPage > 0) {
        this.page = selectedPage;
      }
      let data = {
        page: this.page,
        pagesize: this.pagesize,
        ConfigName: this.filters.ConfigName || "",
        SellerId: this.filters.SellerId,
        Remark: this.filters.Remark,
        ChannelId: Number(this.filters.ChannelId),
      };

      app.post("/admin/config/list", data, (result) => {
        this.table_data = result.data.data;
        this.total = result.data.total;
        for (let i = 0; i < this.table_data.length; i++) {
          for (let j = 0; j < this.seller.length; j++) {
            if (this.seller[j].SellerId == this.table_data[i].SellerId)
              this.table_data[i].SellerName = this.seller[j].SellerName;
          }
        }
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.handleQuery(1);
    },
    handleCurrentChange(val) {
      this.handleQuery(val);
    },
  },
};
</script>
